import type { FC } from 'react';
import type React from 'react';

import { useDynamicReducer } from '@/domains/core/applicationState/hooks/useDynamicReducer';
import { useDynamicSaga } from '@/domains/core/applicationState/hooks/useDynamicSaga';
import {
  articleReviewsReducer,
  rootReviewsStatsSaga,
} from '@/domains/productDiscovery/ArticleReviews/root.ducks.default';

export const ArticleReviewsProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  useDynamicReducer('productDiscovery.articleReviews', articleReviewsReducer);

  useDynamicSaga('getReviewsStats', rootReviewsStatsSaga);

  return <>{children}</>;
};
